<template>
  <section>
    <div class="container wfs--main">
      <div class="row">
          <div class="col-md-12 bread">
              <ol class="bread-crumb breadcrumb-fill0">
                  <li><router-link to="/home">home</router-link></li>
                  <li><a href="javascript:void(0);" class="bread-text ">Ativar Conta</a></li>
              </ol>
          </div>
          
          <!---->
          <card class="col-md-12">
              
              <div class="row">
                  <div class="col-md-6">
                      <h3>{{this.email}}</h3>

                      <div class="alert alert-success" v-if="msg!= null && erro == false">
                        <strong>Sucesso!</strong> Cidadão agora está ativado!
                      </div>

                      <div class="alert alert-danger" v-if="msg!= null && erro == true">
                        <strong>Erro!</strong> Esse link não é valido ou o cidadão pode está ativo!
                      </div>
                  </div> 
                  <div class="col-md-6" >
                      <img src="/img/ilust-protecao.png" style='width: 100%;'>
                  </div>
              </div>
          </card> 
      </div> 
    </div> 
  </section>             
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import 'src/controller/usuarioAlteracaoController.js';
import "src/controller/site/cidadaoController.js";

export default {
  components: {
    Card,
  },
  props: {
    token: {
      require: true,
    },
    email: {
      require:true,
    }
  },
  data() {
    return {
      msg:null,
      erro: false,
    };
  },

  methods: {
    async ativarSuaConta(token){
      try {
        this.msg = null;
        this.erro = false;

        let data = await this.$ativarConta(token);
        
        if(data){
          this.msg = data.msg;
          this.erro = false;
        }
        
      } catch (e) {
        if(e.response.data.error){
          this.msg = e.response.data.error;
        }

        if(e.response.data.msg){
          this.msg = e.response.data.msg;
        }  
        this.erro = true;
      }
    },
    
  },
  beforeMount() {
    this.ativarSuaConta(this.token);
  }, 
}
</script>
<style scoped>
 .card{
    border: 0px solid rgba(0, 0, 0, 0.125) !important;
 }
</style>